import React from 'react'
import { config } from 'config'
import { isCurrentPage } from 'helpers'
import {
  BottomNavContainer,
  BottomNavLeft,
  BottomNavRight,
  BottomNavArrow,
} from './styled'

import HomeImg from './images/Home.webp'
import KyrgyzImg from './images/Kyrgyz.webp'
import KazakhImg from './images/Kazakh.webp'
import TajikImg from './images/Tajik.webp'
import Kazakh2Img from './images/Kazakh2.webp'
import UzbekImg from './images/Uzbek.webp'

const BottomNav = () => {
  const allImages = [
    HomeImg,
    KyrgyzImg,
    KazakhImg,
    TajikImg,
    Kazakh2Img,
    UzbekImg,
  ]
  return (
    <BottomNavContainer>
      {config.pages.map((page) => (
        <React.Fragment key={page.id}>
          {config.pages.indexOf(page) !== 0 && isCurrentPage(page) && (
            <BottomNavLeft
              href={`${config.urlBefore}${config.pages[config.pages.indexOf(page) - 1].id}${config.urlAfter}`}
              $url={allImages[config.pages.indexOf(page) - 1]}
            >
              <span>Предыдущая глава</span>
              <BottomNavArrow $dir="prev" />
            </BottomNavLeft>
          )}{' '}
          {config.pages.indexOf(page) === 0 && isCurrentPage(page) && (
            <div></div>
          )}
        </React.Fragment>
      ))}
      {config.pages.map((page) => (
        <>
          {config.pages.indexOf(page) !== 5 && isCurrentPage(page) && (
            <BottomNavRight
              key={page.id}
              href={`${config.urlBefore}${config.pages[config.pages.indexOf(page) + 1].id}${config.urlAfter}`}
              $url={allImages[config.pages.indexOf(page) + 1]}
            >
              <BottomNavArrow $dir="next" />
              <span>Следующая глава</span>
            </BottomNavRight>
          )}
        </>
      ))}
    </BottomNavContainer>
  )
}
export default BottomNav
